import { Col } from "react-bootstrap";
import { IPropsCard } from "./Interfaces";
import Icon from "components/Icon";
import { formatCurrency } from "utils/currency";
import LoadCard from "./LoadCard";

interface IPropsCardMoney extends IPropsCard {
  value: number;
}

export default function CardMoney({value,xs,md,title,icon,load}:IPropsCardMoney){
  return (
    <Col xs={xs} md={md} className="my-col">
      <div className="my-card">
        {
          title
          ?
          <div className="my-card-title">{icon?<Icon name={icon} styleFamily="regular"/>:<></>}<label>{title}</label></div>
          :
          <div className="my-card-title">{icon?<Icon name={icon}/>:<></>}</div>
        }
        {load?<LoadCard/>:formatCurrency(value)}
      </div>
    </Col>
  );
}